// ! This file was auto-generated from the evisearch OpenAPI schema. Do not override this file.
export const Tags = {
    EmbeddingVectorId: "EmbeddingVectorId",
    ExportOption: "ExportOption",
    Filter: "Filter",
    FilterSuggestion: "FilterSuggestion",
    SearchResult: "SearchResult",
    VectorSearchResult: "VectorSearchResult",
    chart: "chart",
    embeddings: "embeddings",
    export: "export",
    filter: "filter",
    health: "health",
    internal: "internal",
    search: "search",
    vector_search: "vector-search"
} as const;
export type TagName = (typeof Tags)[keyof typeof Tags];
